/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import InternalAccountViewAllPopup from "../../../../components/Accounts/InternalAccount/InternalAccountViewAllPopup/index.jsx";
import Loader from "../../../../components/Loader/Index";
import InternalTransactionViewAllPopup from "../../../../components/Transactions/InternalTransaction/InternalTransactionViewAllPopup/index.jsx";
import ScheduleInternalTransactionViewAllPopup from "../../../../components/Transactions/ScheduleInternalTransaction/ScheduleInternalTransactionViewallpopup/index.jsx";
import CommonAccountApprovalCard from "../../../../components/_utils/CommonAccountApprovalCard";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import {
  addInternalAccountLabel,
  approveInternalAccount,
  getAllInternalAccounts,
  internalAccountDetailsById,
  rejectInternalAccount,
  removeInternalAccountLabel,
} from "../../../../redux/features/accounts/internalAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import {
  getAllCategories,
  panLookUp,
} from "../../../../redux/features/sharedResources/sharedResources.js";
import { internalTransactionsReject } from "../../../../redux/features/transactions/internalTransactions/index.js";
import { scheduledInternalReject } from "../../../../redux/features/transactions/scheduleInternalTransactions/index.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText.js";
import InternalAccountDetails from "../InternalAccountDetails/index.jsx";
import CommonEditHistoryPopUp from "../../../../components/_utils/CommonEditHistoryPopup/index.jsx";
import InternalRejectAllPopup from "../../../../components/Accounts/InternalAccount/InternalRejectAllPopup/index.jsx";

const InternalAccountApproval = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dateRef = useRef(null);
  const filterRef = useRef(null);
  const sidebarRef = useRef(null);
  const dropdownRef = useRef(null);
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const sidebarButtonRef = useRef(null);

  //all useSelector

  const services = useSelector((state) => state.refreshToken.services);
  const { approveInternalAccountData, rejectInternalAccountLoading } =
    useSelector((state) => {
      return state.internalAccount;
    });
  const {
    internalTransactionsViewAllData,
    internalTransactionsViewAllLoading,
  } = useSelector((state) => state?.internalTransactions);
  const { scheduledInternalViewData, scheduledInternalViewLoading } =
    useSelector((state) => state?.scheduleInternalTransactions);

  const labelActionDispatchedRef = useRef(false);

  // all states
  const [dropdownOptions] = useState(
    PaginationConfiguration?.paginationOptions,
  );
  const [page, setPage] = useState(GlobalConfiguration.lengthCheckOne);
  const [remPan, setRemPan] = useState("");
  const [active, setActive] = useState("");
  const [isIfsc, setIsIfsc] = useState("");
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState({});
  const [remIFSC, setRemIFSC] = useState("");
  const [labelId, setLabelId] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [pageSize, setPageSize] = useState(
    PaginationConfiguration?.paginationSmall,
  );
  const [deniedId, SetdeniedId] = useState(null);
  const [inputData, setInputData] = useState([]);
  const [panNumber, setPanNumber] = useState("");
  const [remAccount, setRemAccount] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [allAccounts, setAllAccounts] = useState([]);
  const [declineType, setdeclineType] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [activeType, setActiveType] = useState("pan");
  const [isalertPopup, setAlertPopUp] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [endDateFilter, setEndDateFilter] = useState("");
  const [associateType, setAssociateType] = useState("");
  const [pendingTxnPopup, setPendingTxnPopup] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [searchUserText, setSearchUserText] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [whichBtnClicked, setWhichBtnClicked] = useState({});
  const [startDateFilter, setStartDateFilter] = useState("");
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [pendingNavTarget, setPendingNavTarget] = useState(null);
  const [InternalAccountid, SetInternalAccountid] = useState(null);
  const [accountNumberFilter, setAccountNumberFilter] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [showScheduleTxnPopup, setShowScheduleTxnPopup] = useState(false);
  const [showDeclinePopup, setShowDeclinePopup] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [openInternalAssociate, setOpenInternalAssociate] = useState(false);
  const [isInternalAccountpopUpOpen, SetisInternalAccountpopUpOpen] =
    useState(false);
  const [allInternalAccountsLoading, setAllInternalAccountsLoading] =
    useState(false);
  const [associatePopupDate, setAssociatePopupDate] = useState({
    panNumber: "",
    ifscCode: "",
    accNumber: "",
    accId: "",
    accName: "",
    internalAccNumber: "",
    bank_acc_no: "",
  });
  const [editHistoryPopUp, setEditHistoryPopUp] = useState(false);
  const [editHistoryAccountId, setEditHistoryAccountId] = useState("");

  const hasAnyFilter =
    Boolean(LabelSearchText?.length) ||
    Boolean(accountNumberFilter?.length) ||
    Boolean(panNumber?.length) ||
    Boolean(searchUserText?.length) ||
    (startDateFilter !== "" &&
      endDateFilter !== "" &&
      startDateFilter !== GlobalConfiguration.lengthCheckZero &&
      endDateFilter !== GlobalConfiguration.lengthCheckZero &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter))) ||
    Boolean(isIfsc) ||
    Boolean(searchUserTextDebounce?.length);

  const noTransactionsFromAPI =
    !allInternalAccountsLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allInternalAccountsLoading &&
    allAccounts?.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  const updateAllAccounts = (updatedAccounts) => {
    setAllAccounts(updatedAccounts);
  };

  const handleInputChange = (event) => {
    const value = event.target.value?.replace(/\s+/g, " ").trimStart();

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    if (sanitizedValue.length <= GlobalConfiguration.inputMaxLength) {
      setDeclineReason(sanitizedValue);
    }
  };

  const fetchData = async () => {
    try {
      setAllInternalAccountsLoading(true);

      let queryParams = {
        page_no: page,
        page_size: pageSize,
        approval_status: ["pending"],
      };

      if (
        startDateFilter !== "" &&
        endDateFilter !== "" &&
        startDateFilter !== GlobalConfiguration.lengthCheckZero &&
        endDateFilter !== GlobalConfiguration.lengthCheckZero &&
        !isNaN(Number(startDateFilter)) &&
        !isNaN(Number(endDateFilter))
      ) {
        queryParams.start_date = startDateFilter;
        queryParams.end_date = endDateFilter;
      }
      if (accountNumberFilter !== "") {
        queryParams.bank_account_no = accountNumberFilter;
      }

      if (panNumber !== "") {
        queryParams.pan = panNumber;
      }
      if (searchUserText !== "") {
        queryParams.search_string = searchUserText;
      }
      if (LabelSearchText?.length !== GlobalConfiguration.lengthCheckZero) {
        queryParams.labels = LabelSearchText;
      }
      if (isIfsc !== "") {
        queryParams.ifsc = isIfsc;
      }
      const response = await dispatch(getAllInternalAccounts(queryParams));
      const newData = (response?.payload?.internal_accounts || []).map(
        (account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
        }),
      );

      setAllAccounts(() => [...newData]);
      setMainData(response?.payload);
    } catch (error) {
      console.error("Error fetching internal accounts:", error);
    } finally {
      setAllInternalAccountsLoading(false);
    }
  };

  const onMount = async () => {
    let availableLabels = sessionStorage?.getItem("internalAccountLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  };

  const handleClose = () => {
    setShowLabelsPopup(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
    fetchData();
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message;
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign, recordIdsFromPopup) => {
    setAllInternalAccountsLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(labelId);
    const res = await dispatch(
      addInternalAccountLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (addInternalAccountLabel.fulfilled.match(res)) {
      await fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addInternalAccountLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
    setAllInternalAccountsLoading(false);
    if (addInternalAccountLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (
    labelsToUnassign,
    recordIdsFromPopup,
  ) => {
    setAllInternalAccountsLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(labelId);
    const res = await dispatch(
      removeInternalAccountLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeInternalAccountLabel.fulfilled.match(res)) {
      await fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeInternalAccountLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
    setAllInternalAccountsLoading(false);
    if (removeInternalAccountLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handleClearFilters = () => {
    setAllInternalAccountsLoading(true);
    setStartDateFilter("");
    setEndDateFilter("");
    setShowSearchBar(false);
    setPanNumber("");
    setAccountNumberFilter("");
    setIsIfsc("");
    setLabelSearchText([]);
    setSearchUserTextDebounce("");
    setSearchUserText("");
  };

  const emptyStateButtonProps = noResultsAfterFilter
    ? {
        btnText: "Clear parameters",
        handleFunction: handleClearFilters,
      }
    : {
        btnText: "Internal account dashboard",
        handleFunction: () => navigate("/internal_account_dashboard"),
      };

  const openTxnPopup = (id, acc_Name) => {
    setAssociatePopupDate((prev) => {
      return {
        ...prev,
        accId: id,
        accName: acc_Name,
      };
    });
  };

  const openAssociatedAccountsFound = (ifsc_code, acc_no, pan_no, id) => {
    dispatch(panLookUp({ pan_number: pan_no }));
    setAssociatePopupDate((prev) => {
      return {
        ...prev,
        ifscCode: ifsc_code,
        accNumber: acc_no,
        accId: id,
        panNumber: pan_no,
      };
    });
    setRemPan(pan_no);
    setOpenInternalAssociate(true);
  };

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };

  const handleClosePopup = () => {
     setWhichBtnClicked((p) => {
                  return {
                    ...p,
                    [deniedId]: "none",
                  };
                });
    setShowPopup(false);
    setDeclineReason("");
  };

  // Internal Txn & Schedule internal txn check
  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setShowLoader(true);
    setShowPopup(false);

    const accountInfo = await dispatch(
      internalAccountDetailsById({ id: deniedId }),
    );
    if (
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_internal_transactions === "Y" &&
      (accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_scheduled_internal_transactions === "Y" ||
        accountInfo?.payload?.internal_accounts?.[0]
          ?.pending_scheduled_internal_transactions === "N")
    ) {
      setShowRejectPopup(true);
    } else if (
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_internal_transactions === "N" &&
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_scheduled_internal_transactions === "Y"
    ) {
      setShowScheduleTxnPopup(true);
    } else {
      handleInternalAccountreject(id, AccountIdData);
    }
  };

  const handleInternalAccountreject = async (id, rejection_reason) => {
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    if (
      !rejectInternalAccountLoading ||
      rejectInternalAccountLoading === null
    ) {
      const data = await dispatch(
        rejectInternalAccount({ id, rejection_reason }),
      );

      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "IAAccount",
          },
        });
        return;
      }

      setShowLoader(true);
      await new Promise((resolve) => {
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
      });

      if (data?.payload?.status === false) {
        let errorMsg = "";
        if (data?.payload?.errors?.internal_account?.[0]) {
          errorMsg = data?.payload?.errors?.internal_account[0];
        } else if (data?.payload?.errors?.bank_account_number?.[0]) {
          errorMsg = data?.payload?.errors?.bank_account_number[0];
        } else {
          errorMsg = "An unknown error occurred.";
        }
        const updatedData = allAccounts?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "error" : "pending",
              rejected_on:
                data.payload.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_on
                  : "",
              rejected_by_name:
                data.payload.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_by_name
                  : "",
              rejection_reason: rejection_reason,
              error:
                item.error === "false" && data?.payload?.status === false
                  ? "true"
                  : "false",
              message: data?.payload?.status === false ? errorMsg : "",
              pending_internal_transactions:
                associateType === "rejectAccount" ? "N" : "Y",
              pending_scheduled_internal_transactions:
                associateType === "rejectAccount" ? "N" : "Y",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        setShowPopup(false);
        setShowLoader(false);
        setDeclineReason("");
        setShowRejectPopup(false);

        CommonToast({
          text: errorMsg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      } else {
        const updatedData = allAccounts.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "rejected" : "pending",

              rejected_on:
                data?.payload?.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_on
                  : "",
              rejected_by_name:
                data?.payload?.status === true
                  ? data?.payload?.internal_accounts[0]?.rejected_by_name
                  : "",
              rejection_reason: rejection_reason,
              error:
                item?.error === "false" && data?.payload?.status === false
                  ? "true"
                  : "false",
              message:
                item?.message === "" && data?.payload?.status === false
                  ? data?.payload?.errors?.internal_accounts[0]
                  : "",
              pending_internal_transactions:
                associateType === "rejectAccount" ? "N" : "Y",
              pending_scheduled_internal_transactions:
                associateType === "rejectAccount" ? "N" : "Y",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        setShowLoader(false);
        setDeclineReason("");
        setShowRejectPopup(false);
        if (data?.payload?.status === true) {
          CommonToast({
            text: "Account rejected successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });
        }
        setShowPopup(false);
      }
    }
  };

  const handleApprovalToastSuccess = () => {
    toast.dismiss();
    CommonToast({
      text: "Account approved successfully.",
      icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
      variant: "var(--success)",
    });
  };

  const handleConfirmAlert = async (transactions) => {
    setShowPopup(false);
    try {
      let allTxnId = [];
      allTxnId =
        !internalTransactionsViewAllLoading &&
        internalTransactionsViewAllData?.transactions?.length >
          GlobalConfiguration.lengthCheckZero
          ? internalTransactionsViewAllData?.transactions.map((data) => {
              return data?.txn_id;
            })
          : [];

      UniversalRefreshToast("Rejecting transaction");

      let data = null;

      if (allTxnId.length > GlobalConfiguration.lengthCheckZero) {
        data = await dispatch(
          internalTransactionsReject({
            id: allTxnId,
            rejection_reason: declineReason,
          }),
        );
      }

      if (data?.payload?.status === false) {
        setShowRejectPopup(false);
        const errorMsg = data?.payload?.errors?.user_unauthorized
          ? data?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data?.payload?.errors?.base) &&
              Array.isArray(data?.payload?.errors?.base[0]?.errors)
            ? data.payload.errors.base[0].errors[0]
            : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

        CommonToast({
          text: errorMsg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });

        setShowLoader(false);
      } else if (data?.payload?.status === true) {
        setShowRejectPopup(false);
        setTimeout(() => {
          toast.dismiss();
          CommonToast({
            text: "Transaction rejected successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });
        }, IntervalConfiguration?.intervalExtraLarge);
        const updatedData = allAccounts?.map((item) => {
          if (item.id === associatePopupDate?.accId) {
            return {
              ...item,
              pending_internal_transactions: "N",
            };
          }
          return item;
        });

        if (associateType === "rejectAccount") {
          allAccounts?.forEach((item) => {
            if (item.id === associatePopupDate?.accId) {
              if (item?.pending_scheduled_internal_transactions === "Y") {
                setTimeout(() => {
                  setShowScheduleTxnPopup(true);
                }, IntervalConfiguration.intervalMedium);
              } else {
                handleInternalAccountreject(
                  associatePopupDate?.accId,
                  declineReason,
                );
              }
            }
          });
        }
        updateAllAccounts(updatedData);
      } else if (data?.payload === undefined) {
        setShowRejectPopup(false);

        CommonToast({
          text: "An error occurred while taking action on this account",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      }
      setShowLoader(false);

      if (associateType === "InternalTxn") {
        setDeclineReason("");
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong. Please try again",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
    }
  };

  const handleApproval = async (id) => {
    setWhichBtnClicked((p) => {
      return {
        ...p,
        [id]: "approve",
      };
    });
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));
    UniversalRefreshToast("approvalaccountsRefresh");

    const data = await dispatch(approveInternalAccount({ id }));

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "IAAccount",
        },
      });
      return;
    }

    let errorMessage = "";
    if (data) {
      const errors = data?.payload?.errors;
      if (errors?.internal_account?.[0]) {
        errorMessage = errors.internal_account[0];
      } else if (errors?.bank_account_number?.[0]) {
        errorMessage = errors.bank_account_number[0];
      } else {
        errorMessage = "An unknown error occurred.";
      }
    }

    if (data) {
      const updatedData = allAccounts.map((item) => {
        if (item.id === id) {
          let lifecycleStatus = "";

          if (data.payload.status === true) {
            lifecycleStatus = "Approved";
          }
          if (data.payload.status === false) {
            lifecycleStatus = "error";
          }

          let message = "";
          if (data.payload.status === false) {
            const errors = data?.payload?.errors;
            if (errors?.internal_account?.[0]) {
              message = errors.internal_account[0];
            } else if (errors?.bank_account_number?.[0]) {
              message = errors.bank_account_number[0];
            }
          }

          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? lifecycleStatus : "pending",
            error:
              item.error === "false" && data?.payload.status === false
                ? "true"
                : "false",
            message:
              item.message === "" && data.payload.status === false
                ? message
                : "",
          };
        }

        return item;
      });

      setAllAccounts(updatedData);

      if (data?.payload.status === false) {
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      }
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
    }, IntervalConfiguration?.intervalExtraLarge);

    setTimeout(() => {
      if (data.payload.status === true) {
        handleApprovalToastSuccess();
      }
    }, IntervalConfiguration?.intervalExtraLarge);
  };

  const InternalAccountDetailsPopUp = async (id) => {
    SetInternalAccountid(id);
    SetisInternalAccountpopUpOpen(!isInternalAccountpopUpOpen);
  };
  const closeBeneAccountDetailModal = () => {
    SetisInternalAccountpopUpOpen(false);
  };

  const fetchData2 = async () => {
    let response;
    let data = [];
    setLoadingData(true);

    switch (active) {
      case "Category":
        response = await dispatch(
          getAllCategories({ search_string: searchUserTextDebounce }),
        );
        data = response?.payload?.categories?.map((itm) => {
          return {
            id: itm.name,
            Category: itm.name,
            Description: itm?.description || "Not given",
          };
        });
        setInputData(data);
        setLoadingData(false);
        break;
      case "Labels":
        data = labels
          ?.filter((itm) => {
            return itm.includes(searchUserTextDebounce);
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;
      default:
        break;
    }
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setPage(Number(page));
    toggleDropdown();
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handlePagination = (page) => {
    setPage(page);
  };

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(convertDate(start));
      setEndDateFilter(convertDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );
    return timestamp;
  };

  // Reject Schedule beneficiary transactions
  const handleRejectScheduleInternalTxn = async () => {
    let id2 =
      !scheduledInternalViewLoading &&
      scheduledInternalViewData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? scheduledInternalViewData?.transactions.map((data) => data?.txn_id)
        : [];

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      let data2 = await dispatch(
        scheduledInternalReject({
          id: id2,

          reason: declineReason,
        }),
      );
      if (data2?.payload?.status === false) {
        const errorMsg2 = data2?.payload?.errors?.user_unauthorized
          ? data2?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data2?.payload?.errors?.base) &&
              Array.isArray(data2?.payload?.errors?.base[0]?.errors)
            ? data2.payload.errors.base[0].errors[0]
            : data2?.payload?.errors?.base?.[0] || "Unknown error occurred";

        CommonToast({
          text: errorMsg2,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });

        setTimeout(() => {
          setShowScheduleTxnPopup(false);
        }, IntervalConfiguration.intervalMedium);

        setShowLoader(false);
      } else if (data2?.payload?.status === true) {
        setShowScheduleTxnPopup(false);
        toast.dismiss();
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });

        setTimeout(() => {
          setShowScheduleTxnPopup(false);
        }, IntervalConfiguration.intervalMedium);

        const updatedData = allAccounts?.map((item) => {
          if (item.id === associatePopupDate?.accId) {
            return {
              ...item,
              pending_scheduled_internal_transactions: "N",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);

        if (associateType === "rejectAccount") {
          handleInternalAccountreject(deniedId, declineReason);
        }
      }
      setDeclineReason("");
      setAssociateType("");
      setShowPopup(false);
    }
  };

  const handleCardClick = (targetPath) => {
    setPendingNavTarget(targetPath);
    setAlertPopUp(true);
  };

  const handleLeaveConfirm = () => {
    setAlertPopUp(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const handleAlertCancel = () => {
    setAlertPopUp(false);
    setPendingNavTarget(null);
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === GlobalConfiguration?.lengthCheckZero) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  useEffect(() => {
    let availableLabels = sessionStorage?.getItem("internalAccountLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, []);

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, [
    page,
    pageSize,
    startDateFilter,
    endDateFilter,
    accountNumberFilter,
    panNumber,
    searchUserText,
    isIfsc,
    LabelSearchText,
  ]);

  useEffect(() => {
    if (active?.length) {
      fetchData2();
    }
  }, [active]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        !(dateRef.current && dateRef.current.contains(event.target))
      ) {
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }

      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        sidebarButtonRef.current &&
        !sidebarButtonRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      {editHistoryPopUp && (
        <CommonEditHistoryPopUp
          closehandleFunction={() => setEditHistoryPopUp(false)}
          resourceType="internal_accounts"
          resourceId={editHistoryAccountId}
        />
      )}
      {isalertPopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext={globalText?.LEAVING_PAGE_WILL_EXIT_FROM_CURRENT_FLOW}
            btnOneText={globalText?.STAY}
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={globalText?.LEAVE}
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}


      {openInternalAssociate && (
        <InternalAccountViewAllPopup
          accountType={globalText?.INTERNAL}
          associateAccount={true}
          flow={"internalAssociatedAccountsApproval"}
          associatepanNumber={associatePopupDate.panNumber}
          IFSC={associatePopupDate.ifscCode}
          accountNumber={associatePopupDate.accNumber}
          onClosepop={() => {
            setOpenInternalAssociate(false);
            setRemPan("");
            setRemAccount("");
            setRemIFSC("");
            setActiveType("pan");
          }}
          associateIFSC={associatePopupDate.ifscCode}
          associateaccountNumber={associatePopupDate.accNumber}
          setOpenInternalAssociate={setOpenInternalAssociate}
          setOpenBeneAssociate={(e) => {}}
          activeType={activeType}
          setActiveType={setActiveType}
          setRemPan={setRemPan}
          setRemAccount={setRemAccount}
          setRemIFSC={setRemIFSC}
          remPan={remPan}
          remAccount={remAccount}
          remIFSC={remIFSC}
          beneAccountId={associatePopupDate.accId}
          typePanBank={"BeneAccPanBankSwitch"}
          onCardNavigate={handleCardClick}
        />
      )}

      {showRejectPopup && (
        <InternalRejectAllPopup
          associateType={associateType}
          pendingTxnPopup={pendingTxnPopup}
          setPendingTxnPopup={setPendingTxnPopup}
          setAssociateType={setAssociateType}
          AccountId={deniedId}
          declineReason={declineReason}
          setDeclineReason={setDeclineReason}
          handleClosePopup={handleClosePopup}
          setShowScheduleTxnPopup={setShowScheduleTxnPopup}
          showScheduleTxnPopup={showScheduleTxnPopup}
          showDeclinePopup={showDeclinePopup}
          setShowDeclinePopup={setShowDeclinePopup}
          setShowRejectPopup={setShowRejectPopup}
          allAccounts={allAccounts}
          associatePopupDate={associatePopupDate}
          updateAllAccounts={updateAllAccounts}
          type="internalAccountApproval"
          setShowLoader={setShowLoader}
       
        />
      )}

   

      {/* Label popup */}
      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex"
        >
          <CommonAssignLabelPopup
            headerTitle={globalText?.ASSIGN_UNASSIGN_LABELS}
            headersubtext={globalText?.LABELS_STATS_USAGE_NOTE}
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={[labelId].filter(Boolean)}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={(allAccounts || [])
              ?.filter((acc) => acc?.id === labelId)
              ?.map((acc) => ({ ...acc, id: acc.id }))}
            onClose={handleClose}
            loading={allInternalAccountsLoading}
            setLoading={setAllInternalAccountsLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}

      {/* Show Internal Account in modal */}
      {isInternalAccountpopUpOpen && (
        <LargePopupRedirect
          headerTitle={globalText?.INTERNAL_ACCOUNT_DETAILS}
          closeiconhandleFunction={() => closeBeneAccountDetailModal()}
          isfullViewrequired={true}
          isscrollRequired={true}
          fullviewhandleFunction={() => {
            navigate(
              `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${InternalAccountid}`,
            );
          }}
        >
          <InternalAccountDetails
            bene_account_id={InternalAccountid}
            onAccountUpdated={fetchData}
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            type={"bene_account_detail_modal"}
            servicesType="BenAdmin"
          />
        </LargePopupRedirect>
      )}

      <div className="h-screen overflow-hidden flex flex-col">
        <div className="relative z-z-index-overlay bg-primary-nav min-h-0 Qmd:min-h-navbar-breadcrumb-height"></div>
        <div className="w-full relative z-z-index-overlay lg:px-padding-base  flex items-center justify-end m-auto ">
          <TopNavComponent
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: isSidebarOpen || allInternalAccountsLoading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: globalText?.SEARCH_INTERNAL_ACCOUNT,
              filterPlaceholder: globalText?.SEARCH_PLACEHOLDER,
              filterItems: [
                {
                  name: globalText?.SEARCH,
                  isMulti: false,
                  value: searchUserText,
                  setValue: setSearchUserText,
                  isDropdown: false,
                  isDisabled: false,
                },
                {
                  name: globalText?.ACCOUNT_NUMBER,
                  short_name: "Internal. Acc",
                  isMulti: false,
                  value: accountNumberFilter,
                  setValue: setAccountNumberFilter,
                  isDropdown: false,
                  valueType: "string",
                  isDisabled: allInternalAccountsLoading ? true : false,
                },
                {
                  name: globalText?.IFSC,
                  short_name: globalText?.IFSC_CODE,
                  isMulti: false,
                  value: isIfsc.toUpperCase(),
                  setValue: setIsIfsc,
                  valueType: "string",
                  isDropdown: false,
                  isDisabled: allInternalAccountsLoading ? true : false,
                },
                {
                  name: globalText?.PAN_NUMBER_DETAILS,
                  short_name: "PAN",
                  isMulti: false,
                  value: panNumber.toUpperCase(),
                  setValue: setPanNumber,
                  valueType: "string",
                  isDropdown: false,
                  isDisabled: allInternalAccountsLoading ? true : false,
                },

                {
                  name: globalText?.ASSIGNED_LABELS,
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: setLabelSearchText,
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: allInternalAccountsLoading,
                },
              ],
              filters: [
                {
                  name: globalText?.DATE_RANGE,
                  filterType: globalText?.CALENDER?.toLowerCase(),
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => handleDateChange(date),
                },
              ],
              isFilterClearAllDisabled: !hasAnyFilter,
              isSearchClearAllDisabled: !hasAnyFilter,
              inputData: inputData,
              active: active,
              setActive: setActive,
              loadingData: loadingData,
              loading: allInternalAccountsLoading,
              setLoading: setLoadingData,
              isShowFilter: true,
              isFilterDisabled: allInternalAccountsLoading,
            }}
          />
        </div>
        {isSidebarOpen ||
          (showInnerSearchBar && (
            <div className="absolute top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity z-z-index-header"></div>
          ))}
        <div
          className={`flex flex-col items-center overflow-hidden w-full h-height-full ${isSidebarOpen || showInnerSearchBar ? "bg-PopUp-BackDrop opacity-light-opacity pointer-events-none" : ""}`}
        >
          {allInternalAccountsLoading ? (
            <div className="loader-container m-auto justify-center items-center flex">
              <Loader />
            </div>
          ) : noResultsAfterFilter || noTransactionsFromAPI ? (
            <div
              className={`${noResultsAfterFilter ? "flex flex-col items-center justify-center m-auto w-full h-full" : "w-full flex flex-col items-center justify-center text-center gap-gap-sm m-auto"}`}
            >
              <div>
                <img
                  src={
                    noResultsAfterFilter
                      ? ICONS?.NO_DATA_FOUND
                      : ICONS?.NO_PENDING_TRANSACTION
                  }
                  alt={
                    noResultsAfterFilter
                      ? "No accounts found"
                      : "no_pending_transaction"
                  }
                  className={
                    noResultsAfterFilter
                      ? "w-graphic-width-md h-graphic-rectangle-height-md"
                      : undefined
                  }
                />
              </div>

              <p
                className={
                  noResultsAfterFilter
                    ? "text-text-primary text-font-sm font-normal text-center font-open-sans mb-margin-sm"
                    : "text-sm text-text-primary"
                }
              >
                {noResultsAfterFilter ? (
                  globalText?.NO_DATA_FOUND
                ) : (
                  <>
                    There are no more accounts that require <br /> your
                    approval.
                  </>
                )}
              </p>

              <PrimaryButton
                enabledBgColor="var(--primary-nav-act)"
                btnText={emptyStateButtonProps.btnText}
                btnType="button"
                handleFunction={emptyStateButtonProps.handleFunction}
                hoverOption="white"
                enabledTextColor="var(--text-primary)"
              />
            </div>
          ) : allAccounts?.length > GlobalConfiguration.lengthCheckZero ? (
            <div className="w-width-full overflow-auto h-full">
              <div
                className={`scroll flex flex-col items-center justify-center w-full overflow-y-auto ${(isSidebarOpen || showInnerSearchBar) && "opacity-dark-opacity"}`}
                ref={filterRef}
              >
                <div
                  className={`scroll flex flex-col items-center lg:w-max-content-width gap-gap-md w-width-full mb-margin-md px-padding-md lg:px-padding-base h-height-full justify-start ${(isSidebarOpen || showInnerSearchBar) && "opacity-dark-opacity"}`}
                >
                  {allAccounts?.map((account, index) => {
                    const asAcc =
                      account?.associate_bank === "Y" ||
                      account?.associate_pan === "Y";

                    const pendingTxn = account?.pending_internal_transactions;
                    const pendingScheduleTxn =
                      account?.pending_scheduled_internal_transactions;

                    const buildAlerts = () => [
                      ...(asAcc !== undefined
                        ? asAcc
                          ? [
                              {
                                isLoading: false,
                                text: globalText?.ASSOCIATED_ACCOUNTS_ARE_FOUND,
                                icon: ICONS?.ALERT,
                                onClick: () => {
                                  setRemPan(account.pan_no);
                                  openAssociatedAccountsFound(
                                    account?.ifsc_code,
                                    account?.bank_acc_no,
                                    account?.pan_no,
                                    account?.id,
                                  );
                                },
                              },
                            ]
                          : []
                        : [
                            {
                              isLoading: true,
                              text: globalText?.CHECKING_ASSOCIATED_ACCOUNT,
                            },
                          ]),

                      ...(pendingTxn !== undefined
                        ? pendingTxn === "Y"
                          ? [
                              {
                                isLoading: false,
                                text: globalText?.PENDING_TRANSACTIONS_FOUND,
                                icon: ICONS?.ALERT,
                                onClick: () => {
                                  openTxnPopup(account?.id, account?.name);
                                  setdeclineType("");
                                  setShowRejectPopup(true);
                                  setPendingTxnPopup(true);
                                  setShowDeclinePopup(false)
                                  setAssociateType("InternalTxn");
                                  setAssociatePopupDate((prev) => {
                                    return {
                                      ...prev,
                                      accNumber: account?.bank_acc_no,
                                      internalAccNumber: account?.id,
                                      bank_acc_no: account?.bank_acc_no,
                                    };
                                  });
                                },
                              },
                            ]
                          : []
                        : [
                            {
                              isLoading: true,
                              text: globalText?.CHECKING_PENDING_TRANSACTIONS,
                            },
                          ]),

                      ...(pendingScheduleTxn !== undefined
                        ? pendingScheduleTxn === "Y"
                          ? [
                              {
                                isLoading: false,
                                text: globalText?.PENDING_SCHEDULES_FOUND,
                                icon: ICONS?.ALERT,
                                onClick: () => {
                                  openTxnPopup(account?.id, account?.name);
                                  setShowScheduleTxnPopup(true);
                                  setAssociateType("scheduleInternalTxn");
                                  setShowScheduleTxnPopup(true);
                                  setShowRejectPopup(true);
                                    setShowDeclinePopup(false)
                                },
                              },
                            ]
                          : []
                        : [
                            {
                              isLoading: true,
                              text: globalText?.CHECKING_SCHEDULE_PENDING_TRANSACTIONS,
                            },
                          ]),
                    ];

                    return (
                      <div
                        key={account.id}
                        className={`w-full ${index === GlobalConfiguration.lengthCheckZero && "mt-margin-md"}`}
                      >
                        <CommonAccountApprovalCard
                          overrideAutoLoader
                          whichBtnClicked={
                            whichBtnClicked?.[account.id] ?? "none"
                          }
                          entries={[
                            [
                              {
                                type: "textSubtext",
                                text: account.name,
                                subText: globalText?.ACCOUNT_NAME,
                              },
                              {
                                type: "textSubtext",
                                text: account.email_id,
                                subText: globalText?.EMAIL_ID,
                              },
                              {
                                type: "textSubtext",
                                text: "+91 " + account.contact_no,
                                subText: globalText?.CONTACT_NUMBER,
                              },
                              {
                                type: "cta",
                                text: account.account_type,
                                subText: globalText?.ACCOUNT_STATE,
                                onClick: (e) => {
                                  if (services?.includes("PLogin")) {
                                    setEditHistoryPopUp(true);
                                    setEditHistoryAccountId(account?.id);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "PLogin",
                                      },
                                    });
                                  }
                                },
                              },
                            ],

                            [
                              {
                                type: "textSubtext",
                                text: account.bank_account_holder_full_name,
                                subText: globalText?.BANK_ACCOUNT_HOLDER_NAME,
                              },
                              {
                                type: "accountNumber",
                                text: account.bank_acc_no,
                                subText: globalText?.ACCOUNT_NUMBER,
                                ifsc: account.ifsc_code,
                              },
                              {
                                type: "textSubtext",
                                text: account.ifsc_code,
                                subText: globalText?.IFSC,
                              },
                              {
                                type: "textSubtextX2",
                                text: account.pan_no,
                                subText: globalText?.PAN_NUMBER_DETAILS,
                                text1: account.gstin_detail || "Not given",
                                subText1: globalText?.GST_NUMBER_DETAILS,
                              },
                            ],

                            [
                              {
                                type: "cta",
                                text:
                                  account?.labels?.join(", ") || "Not assigned",
                                subText: globalText?.LABELS,
                                onClick: (e) => {
                                  if (
                                    services?.includes("ALabel") &&
                                    services?.includes("RLabel")
                                  ) {
                                    e.stopPropagation();
                                    setLabelId(account?.id);
                                    setShowLabelsPopup(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "ALabel,RLabel",
                                      },
                                    });
                                  }
                                },
                              },
                            ],
                          ]}
                          approveClick={() => handleApproval(account.id)}
                          rejectClick={() => {
                            setWhichBtnClicked((p) => {
                              return {
                                ...p,
                                [account?.id]: "reject",
                              };
                            });
                            handleOpenPopup(account?.id);
                            setdeclineType("rejectedAccount");
                            setAssociateType("rejectAccount");
                            setShowDeclinePopup(true);
                            setShowRejectPopup(true);
                            setAssociatePopupDate((prev) => {
                              return {
                                ...prev,
                                accNumber: account?.bank_acc_no,
                              };
                            });

                            openTxnPopup(
                              account?.id,
                              account?.name,
                              account?.bank_acc_no,
                            );
                            setAssociateType("rejectAccount");
                          }}
                          ctaBtn1Text={globalText?.MORE_DETAILS}
                          ctaBtn1OnClick={
                            account.approval_status ===
                              globalText?.PENDING_NEW && !loading[account.id]
                              ? () => InternalAccountDetailsPopUp(account.id)
                              : undefined
                          }
                          cardState={
                            account.approval_status === globalText?.APPROVED &&
                            account.error === "false" &&
                            approveInternalAccountData &&
                            !loading[account.id]
                              ? "single"
                              : account.approval_status ===
                                    globalText?.REJECTED_ACC &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? account.rejection_reason
                                  ? "double"
                                  : "single"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "single"
                                  : "default"
                          }
                          overlay1Text={
                            account.approval_status === globalText?.APPROVED &&
                            account.error === "false" &&
                            approveInternalAccountData &&
                            !loading[account.id]
                              ? globalText?.APPROVED
                              : account.approval_status ===
                                    globalText?.REJECTED_ACC &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "Rejected"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "Failed to take action!"
                                  : undefined
                          }
                          overlay1Subtext={
                            account.approval_status === globalText?.APPROVED &&
                            account.error === "false" &&
                            approveInternalAccountData &&
                            !loading[account.id]
                              ? "This account has been approved."
                              : account.approval_status ===
                                    globalText?.REJECTED_ACC &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "This account has been rejected."
                                : account.error === "true" &&
                                    !loading[account.id]
                                  ? account.message ||
                                    "An error occurred while taking action on this account."
                                  : undefined
                          }
                          overlay1Icon={
                            account.approval_status === globalText?.APPROVED &&
                            account.error === "false" &&
                            approveInternalAccountData &&
                            !loading[account.id]
                              ? ICONS?.APPROVED_LINEAR
                              : account.approval_status ===
                                    globalText?.REJECTED_ACC &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? ICONS?.REJECTED_RED
                                : account.error === "true" &&
                                    !loading[account.id]
                                  ? ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                  : undefined
                          }
                          overlay1CtaText={
                            (account.approval_status === globalText?.APPROVED &&
                              account.error === "false" &&
                              approveInternalAccountData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status ===
                              globalText?.REJECTED_ACC &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? "View account"
                              : undefined
                          }
                          overlay1CtaOnClick={
                            (account.approval_status === globalText?.APPROVED &&
                              account.error === "false" &&
                              approveInternalAccountData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status ===
                              globalText?.REJECTED_ACC &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? () => InternalAccountDetailsPopUp(account.id)
                              : undefined
                          }
                          overlay1CtaInactive={false}
                          overlay1CtaDisabled={loading[account.id]}
                          overlay1CtaLoading={loading[account.id]}
                          overlay2Text={
                            account.approval_status ===
                              globalText?.REJECTED_ACC &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? account.rejection_reason
                              : undefined
                          }
                          overlay2Subtext={
                            account.approval_status ===
                              globalText?.REJECTED_ACC &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? globalText?.REJECT_REASON_LABEL
                              : undefined
                          }
                          alerts={buildAlerts()}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : null}

          <div
            className={`${allAccounts?.length === GlobalConfiguration.lengthCheckZero ? "hidden" : "block"} ${isSidebarOpen && " hidden lg:block"} w-full z-z-index-fixed-ui`}
          >
            <div
              className={`${(isSidebarOpen || showInnerSearchBar) && "pointer-events-none"}`}
            >
              <PaginationComponent
                handleSelect={handleSelect}
                selectedValue={selectedValue}
                data={mainData}
                pageSize={pageSize}
                dropdownOptions={dropdownOptions}
                handlePagination={handlePagination}
                currentPage={page}
                setIsOpen={setIsOpen}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InternalAccountApproval;
